import { Colors } from './CommonStyling';

export const CommonDetails = {
  contactUsMsisdn: '087 250 2644',
  contactUsEmail: 'opflendingsupport@vodacom.co.za',
  vodalendTermsConditions: 'https://vodalend.vodacombusiness.co.za/TermsAndConditions',
  vodalendPrivacyPolicy: 'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/pdf/opf-privacy-supplement.pdf'
};

export const appStatuses = {
  Closed: 'Closed',
  Declined: 'Declined',
  Submitted: 'Submitted',
  InAssessment: 'InAssessment',
  QuoteAvailable: 'QuoteAvailable',
  QuoteAccepted: 'QuoteAccepted',
  AwaitingLegals: 'AwaitingLegals',
  LegalsSubmitted: 'LegalsSubmitted',
  AwaitingDisbursement: 'AwaitingDisbursement',
  Disbursed: 'Disbursed',
  Settled: 'Settled',
  CreditFacilityCreated: 'CreditFacilityCreated',
  Active: 'Active',
  AwaitingCustomerAssessment:'AwaitingCustomerAssessment'
};

export const appStatusesText = {
  Closed: 'Closed',
  Declined: 'Declined',
  Submitted: 'Submitted',
  InAssessment: 'In Assessment',
  QuoteAvailable: 'Quote Available',
  QuoteAccepted: 'Quote Accepted',
  AwaitingLegals: 'Legal Contract Review',
  LegalsSubmitted: 'Legal Contract Submitted',
  AwaitingDisbursement: 'Awaiting Disbursement',
  Disbursed: 'Disbursed',
  Settled: 'Settled',
  CreditFacilityCreated: 'Cash Flow Facility Approved',
  Active: 'Active',
  AwaitingCustomerAssessment:'Awaiting Customer Assessment',
  Pending: 'Pending'
};

export const appStatusSubtext = {
  Closed : 'Your funds have been paid in full to your chosen account. Thank you.',
  Declined : 'Unfortunately after review, your application has been declined.',
  Submitted :'Our team is currently reviewing your application and you should receive feedback within 48 hours.',
  InAssessment: 'Our team is currently reviewing your application and you should receive feedback within 48 hours.',
  QuoteAvailable : 'Your application has been approved and your quote will be finalised soon.',
  QuoteAccepted: 'Your quotation has been submitted, and our team shall provide further feedback within 48 hours.',
  AwaitingLegals: 'Your application requires legal contract review.',
  LegalsSubmitted: 'Your legal contract has been submitted, and our team shall provide further feedback within 48 hours.',
  AwaitingDisbursement: 'Our team shall provide disbursement of your application shortly within 48 hours.',
  Disbursed: 'Your application funding has been disbursed to your account.',
  Settled: 'Your application funding has been settled.',
  CreditFacilityCreated: 'Your cash flow facility has been created.',
  AwaitingCustomerAssessment:'A quotation is available for your application, but requires user verification.',
  Pending: 'Our team is currently reviewing your application and you should receive feedback within 48 hours.',
  Active : 'Your funds have been disbursed and should reflect in your bank account within 24 hours'
};

export const applicationStatusSubText = {
  Submitted :'Our team is currently reviewing your application and you should receive feedback within 48 hours.',
  Pending: 'Our team is currently reviewing your application and you should receive feedback within 48 hours.',
  QuoteAvailable : 'Your application has been approved and your quote will be finalised soon.',
  Active : 'Your funds have been disbursed and should reflect in your bank account within 24 hours',
  Closed : 'Your funds have been paid in full to your chosen account. Thank you.',
  Declined : 'Unfortunately after review, your application has been declined.'
};

export const applicationStatusColors = {
  'Submitted': '#CA7A00',
  'InAssessment': '#FF7F00',
  'QuoteAvailable': Colors.AccentBlue4,
  'QuoteAccepted': Colors.AccentBlue4,
  'Closed': Colors.GreyScale13,
  'Declined': '#BD0000',
  'AwaitingLegals': Colors.AccentBlue4,
  'LegalsSubmitted': Colors.AccentBlue4,
  'AwaitingDisbursement': Colors.AccentPurple5,
  'CreditFacilityCreated': '#108846',
  'Settled': Colors.GreyScale13,
  'Disbursed': '#108846',
  'Active': '#14872B',
  'AwaitingCustomerAssessment':Colors.AccentBlue4,
  'Pending' : '#5E2750'
};

export const applicationProduct = {
  RCF: 'CreditFacility',
  BTA: 'Term'
};

export const OPF_APPLICATION_PROGRESS_STATES = [
  appStatuses.AwaitingDisbursement,
  appStatuses.AwaitingLegals,
  appStatuses.CreditFacilityCreated,
  appStatuses.InAssessment,
  appStatuses.LegalsSubmitted,
  appStatuses.QuoteAvailable,
  appStatuses.QuoteAccepted,
  appStatuses.Submitted,
  appStatuses.AwaitingCustomerAssessment
];

export const appTermText = {
  '3 months' : 3,
  '6 months' : 6,
  '9 months' : 9,
  '12 months' : 12
};

export const preSubmissionUrls = ['/fundingApplicationDetails', '/products','/apply/identityVerification',
  '/apply/personalDetails','/apply/businessVerification','/apply/businessList','/apply/businessDetails',
  '/apply/businessDirectors','/apply/financialDetails'];
